module.exports = __webpack_public_path__ + "media/images/flags/32/El-Salvador-ce0cb53b7dcf09072e45ad13ebd98bac.png";